'use client'

import { BoundaryAction } from '@/app/_components/route-boundary'
import { authClient } from '@/auth-client'

// Session-aware return affordance for the global 404. A signed-in reader goes
// back to the journey; a visitor goes to the landing. Read client-side so the
// 404 shell itself stays static (no headers() in not-found.tsx — the hard-404
// path serves the prerendered shell). Until the session resolves the href is
// the landing default; the swap is a silent href change, never a visual flash.
export function ReturnLink() {
    const { data: session } = authClient.useSession()

    return (
        <BoundaryAction href={session?.user ? '/journey' : '/'}>
            return →
        </BoundaryAction>
    )
}
